import DOMPurify from "dompurify";

/**
 * Nettoie tout HTML avant son insertion dans le DOM.
 * DOMPurify conserve le balisage de présentation autorisé et retire notamment
 * les scripts, les gestionnaires d'événements et les URL dangereuses.
 */
const sanitizeHtml = (value: unknown): string => {
  if (typeof value !== "string") {
    return "";
  }

  return DOMPurify.sanitize(value);
};

export default sanitizeHtml;
